import {HttpContextToken} from '@angular/common/http';

/**
 * Marks a request to a third-party public endpoint. Such requests must never
 * receive application authentication or tenant context.
 */
export const EXTERNAL_PUBLIC_REQUEST = new HttpContextToken<boolean>(() => false);
